export const nextDay = (day: Date) => {
  const n = new Date(day.valueOf());
  n.setDate(day.getDate() + 1);
  return n;
};
